<script>
import Layout from '@layouts/main';
import CostTypeForm from '@views/costTypes/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'CarTypeEdit',
  components: {
    Layout,
    CostTypeForm,
  },
  mixins: [beforeLeaveAfterEdit],
  page() {
    return {
      title: `${this.$t('titles.edit_cost_type')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.cost_type'),
          to: { name: 'costTypes.index' },
        },
        {
          text: `${this.$t('titles.edit_cost_type')} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  methods: {
    update(callback) {
      this.setUnchanged();
      if (!callback) {
        this.$router.push({
          name: 'costTypes.index',
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.edit_cost_type')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CostTypeForm :loaded-id="$route.params.id" @submitted="update" @entity-changed="initBeforeLeave" />
    </b-card>
  </Layout>
</template>
